// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.suggestion-card-horizontal {
  min-width: 260px;
  scroll-snap-align: start;
}

/* Actions */
.suggestion-actions {
  display: flex;
  justify-content: space-between;
  margin-top: auto;
  gap: 8px;
}

.btn-like {
  flex: 1 1;
  /* background: #22c55e; */
  background: var(--primary-200);
  color: white;
  border: none;
  padding: 10px;
  border-radius: 10px;
  cursor: pointer;

  display:flex;
  align-items:center;
  justify-content:center;
  gap:5px;
}

.btn-pass {
  flex: 1 1;
  background: #ef4444;
  color: white;
  border: none;
  padding: 10px;
  border-radius: 10px;
  cursor: pointer;

  display:flex;
  align-items:center;
  justify-content:center;
  gap:5px;
}

/* Matching discovery cards, scoped to the high-tech matching page. */
.matching-page .suggestion-card-horizontal {
  display: flex;
  flex: 0 0 292px;
  min-width: 292px;
  min-height: 214px;
  flex-direction: column;
  scroll-snap-align: start;
}

.matching-page .suggestion-card-horizontal .match-header strong {
  display: block;
  max-width: 178px;
}

.matching-page .suggestion-card-horizontal .match-body {
  display: flex;
  flex: 1 1;
  flex-direction: column;
  justify-content: center;
}

.matching-page .suggestion-card-horizontal .match-body div {
  display: flex;
  align-items: center;
  gap: 7px;
}

.matching-page .suggestion-actions { gap: 8px; margin-top: auto; }

.matching-page .btn-like,
.matching-page .btn-pass {
  min-height: 39px;
  border: 1px solid;
  border-radius: 10px;
  font-family: Inter, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
  font-size: .71rem;
  font-weight: 800;
  transition: .18s ease;
}

.matching-page .btn-like { border-color: #e95a13; background: #e95a13; box-shadow: 0 7px 14px rgba(233, 90, 19, .16); }
.matching-page .btn-like:hover { background: #d84f0d; transform: translateY(-1px); }
.matching-page .btn-pass { border-color: rgba(78, 119, 153, .22); color: #4e7799; background: #ffffff; }
.matching-page .btn-pass:hover { border-color: rgba(233, 90, 19, .3); color: #d84f0d; background: #fff3ec; }

@media (max-width: 768px) {
  .matching-page .suggestion-card-horizontal {
    flex-basis: min(292px, calc(100vw - 44px));
    min-width: min(292px, calc(100vw - 44px));
    min-height: 204px;
    padding: 15px;
    border-radius: 15px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/componentsL/matching/SuggestionCard.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,yBAAyB;EACzB,8BAA8B;EAC9B,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,eAAe;;EAEf,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,OAAO;AACT;;AAEA;EACE,SAAO;EACP,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,eAAe;;EAEf,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,OAAO;AACT;;AAEA,qEAAqE;AACrE;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAO;EACP,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,qCAAqC,QAAQ,EAAE,gBAAgB,EAAE;;AAEjE;;EAEE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,oEAAoE;EACpE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,2BAA2B,qBAAqB,EAAE,mBAAmB,EAAE,6CAA6C,EAAE;AACtH,iCAAiC,mBAAmB,EAAE,2BAA2B,EAAE;AACnF,2BAA2B,qCAAqC,EAAE,cAAc,EAAE,mBAAmB,EAAE;AACvG,iCAAiC,mCAAmC,EAAE,cAAc,EAAE,mBAAmB,EAAE;;AAE3G;EACE;IACE,0CAA0C;IAC1C,yCAAyC;IACzC,iBAAiB;IACjB,aAAa;IACb,mBAAmB;EACrB;AACF","sourcesContent":[".suggestion-card-horizontal {\n  min-width: 260px;\n  scroll-snap-align: start;\n}\n\n/* Actions */\n.suggestion-actions {\n  display: flex;\n  justify-content: space-between;\n  margin-top: auto;\n  gap: 8px;\n}\n\n.btn-like {\n  flex: 1;\n  /* background: #22c55e; */\n  background: var(--primary-200);\n  color: white;\n  border: none;\n  padding: 10px;\n  border-radius: 10px;\n  cursor: pointer;\n\n  display:flex;\n  align-items:center;\n  justify-content:center;\n  gap:5px;\n}\n\n.btn-pass {\n  flex: 1;\n  background: #ef4444;\n  color: white;\n  border: none;\n  padding: 10px;\n  border-radius: 10px;\n  cursor: pointer;\n\n  display:flex;\n  align-items:center;\n  justify-content:center;\n  gap:5px;\n}\n\n/* Matching discovery cards, scoped to the high-tech matching page. */\n.matching-page .suggestion-card-horizontal {\n  display: flex;\n  flex: 0 0 292px;\n  min-width: 292px;\n  min-height: 214px;\n  flex-direction: column;\n  scroll-snap-align: start;\n}\n\n.matching-page .suggestion-card-horizontal .match-header strong {\n  display: block;\n  max-width: 178px;\n}\n\n.matching-page .suggestion-card-horizontal .match-body {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.matching-page .suggestion-card-horizontal .match-body div {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n}\n\n.matching-page .suggestion-actions { gap: 8px; margin-top: auto; }\n\n.matching-page .btn-like,\n.matching-page .btn-pass {\n  min-height: 39px;\n  border: 1px solid;\n  border-radius: 10px;\n  font-family: Inter, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif;\n  font-size: .71rem;\n  font-weight: 800;\n  transition: .18s ease;\n}\n\n.matching-page .btn-like { border-color: #e95a13; background: #e95a13; box-shadow: 0 7px 14px rgba(233, 90, 19, .16); }\n.matching-page .btn-like:hover { background: #d84f0d; transform: translateY(-1px); }\n.matching-page .btn-pass { border-color: rgba(78, 119, 153, .22); color: #4e7799; background: #ffffff; }\n.matching-page .btn-pass:hover { border-color: rgba(233, 90, 19, .3); color: #d84f0d; background: #fff3ec; }\n\n@media (max-width: 768px) {\n  .matching-page .suggestion-card-horizontal {\n    flex-basis: min(292px, calc(100vw - 44px));\n    min-width: min(292px, calc(100vw - 44px));\n    min-height: 204px;\n    padding: 15px;\n    border-radius: 15px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
